import { SurchargesKpisActionTypes } from './constants';

export const INIT_STATE = {
    loadingTotalNoSurcharges: false,
    totalNoSurcharges: null,
    errorTotalNoSurcharges: null,
    loadingTotalNoNonShipmentSurcharges: false,
    totalNoNonShipmentSurcharges: null,
    errorTotalNoNonShipmentSurcharges: null,
    loadingTotalSurcharges: false,
    totalSurcharges: null,
    errorTotalSurcharges: null,
    loadingTotalNonShipmentSurcharges: false,
    totalNonShipmentSurcharges: null,
    errorTotalNonShipmentSurcharges: null,
    loadingSurchargeSummary: false,
    surchargeSummary: null,
    errorSurchargeSummary: null,
    loadingNonShipmentSurchargeSummary: false,
    nonShipmentSurchargeSummary: null,
    errorNonShipmentSurchargeSummary: null,
    loadingSurchargesByTimeframe: false,
    surchargesByTimeframe: null,
    errorSurchargesByTimeframe: null,
};

type SurchargesKpisAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type SurchargesKpisState = {
    loadingTotalNoSurcharges: Boolean,
    totalNoSurcharges: any,
    errorTotalNoSurcharges: any,
    loadingTotalNoNonShipmentSurcharges: Boolean,
    totalNoNonShipmentSurcharges: any,
    errorTotalNoNonShipmentSurcharges: any,
    loadingTotalSurcharges: Boolean,
    totalSurcharges: any,
    errorTotalSurcharges: any,
    loadingTotalNonShipmentSurcharges: Boolean,
    totalNonShipmentSurcharges: any,
    errorTotalNonShipmentSurcharges: any,
    loadingSurchargeSummary: Boolean,
    surchargeSummary: any,
    errorSurchargeSummary: any,
    loadingNonShipmentSurchargeSummary: Boolean,
    nonShipmentSurchargeSummary: any,
    errorNonShipmentSurchargeSummary: any,
    loadingSurchargesByTimeframe: Boolean,
    surchargesByTimeframe: any,
    errorSurchargesByTimeframe: any,
};

const SurchargesKpis = (state: SurchargesKpisState = INIT_STATE, action: SurchargesKpisAction): any => {
    switch (action.type) {
        case SurchargesKpisActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case SurchargesKpisActionTypes.GET_TOTAL_NO_SURCHARGES: {
                    return { ...state, loadingTotalNoSurcharges: false, totalNoSurcharges: action.payload.data };
                }
                case SurchargesKpisActionTypes.GET_TOTAL_NO_NON_SHIPMENT_SURCHARGES: {
                    return { ...state, loadingTotalNoNonShipmentSurcharges: false, totalNoNonShipmentSurcharges: action.payload.data };
                }
                case SurchargesKpisActionTypes.GET_TOTAL_SURCHARGES_COST: {
                    return { ...state, loadingTotalSurcharges: false, totalSurcharges: action.payload.data };
                }
                case SurchargesKpisActionTypes.GET_TOTAL_NON_SHIPMENT_SURCHARGES_COST: {
                    return { ...state, loadingTotalNonShipmentSurcharges: false, totalNonShipmentSurcharges: action.payload.data };
                }
                case SurchargesKpisActionTypes.GET_SURCHARGE_SUMMARY: {
                    return { ...state, loadingSurchargeSummary: false, surchargeSummary: action.payload.data };
                }
                case SurchargesKpisActionTypes.GET_NON_SHIPMENT_SURCHARGE_SUMMARY: {
                    return { ...state, loadingNonShipmentSurchargeSummary: false, nonShipmentSurchargeSummary: action.payload.data };
                }
                case SurchargesKpisActionTypes.GET_SURCHARGES_BY_TIMEFRAME: {
                    return { ...state, loadingSurchargesByTimeframe: false, surchargesByTimeframe: action.payload.data };
                }
                default:
                    return { ...state, loadingTotalNoSurcharges: false, loadingTotalNoNonShipmentSurcharges: false, loadingTotalSurcharges: false, loadingTotalNonShipmentSurcharges: false, loadingSurchargeSummary: false, loadingNonShipmentSurchargeSummary: false, loadingSurchargesByTimeframe: false };
            }

        case SurchargesKpisActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case SurchargesKpisActionTypes.GET_TOTAL_NO_SURCHARGES: {
                    return { ...state, loadingTotalNoSurcharges: false, errorTotalNoSurcharges: action.payload.error };
                }
                case SurchargesKpisActionTypes.GET_TOTAL_NO_NON_SHIPMENT_SURCHARGES: {
                    return { ...state, loadingTotalNoNonShipmentSurcharges: false, errorTotalNoNonShipmentSurcharges: action.payload.error };
                }
                case SurchargesKpisActionTypes.GET_TOTAL_SURCHARGES_COST: {
                    return { ...state, loadingTotalSurcharges: false, errorTotalSurcharges: action.payload.error };
                }
                case SurchargesKpisActionTypes.GET_TOTAL_NON_SHIPMENT_SURCHARGES_COST: {
                    return { ...state, loadingTotalNonShipmentSurcharges: false, errorTotalNonShipmentSurcharges: action.payload.error };
                }
                case SurchargesKpisActionTypes.GET_SURCHARGE_SUMMARY: {
                    return { ...state, loadingSurchargeSummary: false, errorSurchargeSummary: action.payload.error };
                }
                case SurchargesKpisActionTypes.GET_NON_SHIPMENT_SURCHARGE_SUMMARY: {
                    return { ...state, loadingNonShipmentSurchargeSummary: false, errorNonShipmentSurchargeSummary: action.payload.error };
                }
                case SurchargesKpisActionTypes.GET_SURCHARGES_BY_TIMEFRAME: {
                    return { ...state, loadingSurchargesByTimeframe: false, errorSurchargesByTimeframe: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case SurchargesKpisActionTypes.GET_TOTAL_NO_SURCHARGES:
            return { ...state, loadingTotalNoSurcharges: true, totalNoSurcharges: null };
        case SurchargesKpisActionTypes.GET_TOTAL_NO_NON_SHIPMENT_SURCHARGES:
            return { ...state, loadingTotalNoNonShipmentSurcharges: true, totalNoNonShipmentSurcharges: null };
        case SurchargesKpisActionTypes.GET_TOTAL_SURCHARGES_COST:
            return { ...state, loadingTotalSurcharges: true, totalSurcharges: null };
        case SurchargesKpisActionTypes.GET_TOTAL_NON_SHIPMENT_SURCHARGES_COST:
            return { ...state, loadingTotalNonShipmentSurcharges: true, totalNonShipmentSurcharges: null };
        case SurchargesKpisActionTypes.GET_SURCHARGE_SUMMARY:
            return { ...state, loadingSurchargeSummary: true, surchargeSummary: null };
        case SurchargesKpisActionTypes.GET_NON_SHIPMENT_SURCHARGE_SUMMARY:
            return { ...state, loadingNonShipmentSurchargeSummary: true, nonShipmentSurchargeSummary: null };
        case SurchargesKpisActionTypes.GET_SURCHARGES_BY_TIMEFRAME:
            return { ...state, loadingSurchargesByTimeframe: true, surchargesByTimeframe: null };
        default:
            return { ...state };
    }
};

export default SurchargesKpis;
